import { useRef } from 'react';
import { FaImage, FaStar, FaTimes, FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import { FieldShell } from './FieldShell';
import { useDomFieldId } from './_useFieldName';

const BLOCK = 'LStudio__app_field';

/*
    🔥 GALERÍA DE IMÁGENES

    Distinto de FieldFile: acá se ven las miniaturas, se ordenan y se
    elige la portada. Es lo que necesita cualquier producto o proyecto.

    La primera de la lista es la portada; la estrella la mueve al frente.
*/

const onGetSrc = (item) => (typeof item === 'string' ? item : URL.createObjectURL(item));

export const FieldImages = ({
    id, label, hint, error,
    images = [], onChange,
    accept = 'image/*', maxImages = 8, maxSize = 3145728,
    isDisabled = false, span = 2,
}) => {

    const REF__useRefInput = useRef(null);

    const IS_FULL = images.length >= maxImages;

    const onAdd = (event) => {
        const FILES = Array.from(event.target.files ?? [])
            .filter((f) => f.size <= maxSize)
            .slice(0, maxImages - images.length);
        onChange?.([...images, ...FILES]);
        if (REF__useRefInput.current) REF__useRefInput.current.value = '';
    };

    const onRemove = (index) => onChange?.(images.filter((_, i) => i !== index));

    const onMove = (index, delta) => {
        const NEXT = [...images];
        const TARGET = index + delta;
        if (TARGET < 0 || TARGET >= NEXT.length) return;
        [NEXT[index], NEXT[TARGET]] = [NEXT[TARGET], NEXT[index]];
        onChange?.(NEXT);
    };

    const onMakeCover = (index) => {
        const NEXT = [...images];
        const [ITEM] = NEXT.splice(index, 1);
        onChange?.([ITEM, ...NEXT]);
    };

    const DOM_ID = useDomFieldId(id);

    return (
        <FieldShell id={DOM_ID} label={label} error={error} span={span} isDisabled={isDisabled}
            hint={hint ?? `La primera es la portada · ${images.length}/${maxImages}`} >

            <div className={`${BLOCK}__gallery`}>

                {
                    images.map((item, index) => (
                        <figure key={index} className={`${BLOCK}__thumb`} data-cover={index === 0}>

                            <img src={onGetSrc(item)} alt="" className={`${BLOCK}__thumb_img`} />

                            {index === 0 && <figcaption className={`${BLOCK}__thumb_badge`}>Portada</figcaption>}

                            <div className={`${BLOCK}__thumb_actions`}>

                                <button type="button" aria-label="Mover a la izquierda"
                                    disabled={isDisabled || index === 0} onClick={() => onMove(index, -1)} >
                                    <FaArrowLeft />
                                </button>

                                <button type="button" aria-label="Hacer portada"
                                    disabled={isDisabled || index === 0} onClick={() => onMakeCover(index)} >
                                    <FaStar />
                                </button>

                                <button type="button" aria-label="Mover a la derecha"
                                    disabled={isDisabled || index === images.length - 1}
                                    onClick={() => onMove(index, 1)} >
                                    <FaArrowRight />
                                </button>

                                <button type="button" aria-label="Quitar" data-danger="true"
                                    disabled={isDisabled} onClick={() => onRemove(index)} >
                                    <FaTimes />
                                </button>

                            </div>

                        </figure>
                    ))
                }

                {
                    !IS_FULL && (
                        <button type="button" className={`${BLOCK}__thumb_add`}
                            disabled={isDisabled} onClick={() => REF__useRefInput.current?.click()} >
                            <FaImage />
                            <span>Agregar</span>
                        </button>
                    )
                }

                <input ref={REF__useRefInput} type="file" accept={accept} multiple
                    className={`${BLOCK}__avatar_input`} onChange={onAdd} disabled={isDisabled} />

            </div>

        </FieldShell>
    );
};
